export const CONTACTS = {
  whatsapp: {
    number: '5513996598656',
    getUrl: (message: string = '') => {
      const encodedMessage = encodeURIComponent(message);
      return `https://wa.me/5513996598656${message ? `?text=${encodedMessage}` : ''}`;
    }
  },
  email: 'contato@waketecnologia.com.br',
  phone: '(13) 99659-8656'
};
